(function() {
        var path = window.location.pathname.replace(/\/$/, '');
        var redirects = {
          '/pages/mission': '/pages/social-impact',
          '/pages/partners': '/pages/social-impact',
          '/pages/our-story': '/pages/about-us',           
          '/pages/corporategifting': '/pages/corporate-gifting',
          '/pages/ingredients': '/pages/products-ingredients', 
          '/pages/find-us': '/pages/store-locator',
          '/pages/faqs': '/pages/faq',
          '/pages/press': '/pages/calyan-press',
          '/pages/jobs': '/pages/careers'
        };

        if (redirects[path]) {
          window.location.replace(redirects[path]);
        }
      })();